import React from 'react'
import './Loader.scss'

const Loader = () => {
  return (
    <div class='loader-overlay'>
      <div class='d-flex justify-content-center align-items-center h-100'>
        <div class='spinner-border text-black' role='status'>
          <span class='sr-only'>Loading...</span>
        </div>
      </div>
    </div>
  )
}

export default Loader
